<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <img src="@/assets/icons/Success.svg" alt="" class="icon" />
      <p class="text">{{ message }}</p>
      <StandardButton :buttonLabel="'Aceptar'" @click="closeModalSuccess" />
    </div>
  </div>
</template>

<script lang="ts">
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { defineComponent, inject } from "vue";
import { successProcessKey } from "@/main";

export default defineComponent({
  name: "ModalSuccess",
  components: {
    StandardButton,
  },
  props: {
    message: {
      type: String,
      default: "Success Process",
    },
  },
  setup() {
    const successProcess = inject(successProcessKey)!;
    const { closeSuccessModal } = successProcess;

    function closeModalSuccess() {
      closeSuccessModal();
    }

    return {
      closeModalSuccess,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/modals/modalSuccessErrorStyle";
</style>
